import { GetPostAppointmentStateUrlDto, useModalState } from '@monument/core';
import { useOnboarding } from '@services/onboarding';
import { PostAppointmentModalState } from './PostAppointmentContext';

export const usePostAppointmentPayment = (
  postApptState?: GetPostAppointmentStateUrlDto,
  clinicianRatingModalVisible: boolean = false,
): PostAppointmentModalState => {
  const upcomingBookingPaymentModalState = useModalState(true);
  const booking = postApptState?.paymentRequest;
  const { hasActiveOnboarding } = useOnboarding();

  return {
    modal: {
      ...upcomingBookingPaymentModalState,
      visible:
        !!booking &&
        upcomingBookingPaymentModalState.visible &&
        !hasActiveOnboarding &&
        !clinicianRatingModalVisible,
    },
    booking,
  };
};
